import { useEffect, useState, useRef } from "react";

function useInactivityRedirect({ inactivityTimeout, popupTimeout, redirectTo }) {
  const [showPopup, setShowPopup] = useState(false);
  const [remainingSeconds, setRemainingSeconds] = useState(popupTimeout / 1000);
  const inactivityTimerRef = useRef(null);
  const popupTimerRef = useRef(null);
  const countdownIntervalRef = useRef(null);

  const resetInactivityTimer = () => {
    clearTimeout(inactivityTimerRef.current);
    inactivityTimerRef.current = setTimeout(() => {
      setShowPopup(true);
      startCountdown();
    }, inactivityTimeout);
  };

  const startCountdown = () => {
    let seconds = popupTimeout / 1000;
    setRemainingSeconds(seconds);
    countdownIntervalRef.current = setInterval(() => {
      seconds -= 1;
      setRemainingSeconds(seconds);
      if (seconds <= 0) {
        clearInterval(countdownIntervalRef.current);
        window.location.href = redirectTo;
      }
    }, 1000);
  };

  const confirmRedirect = () => {
    // 페이지 이동을 하지 않고 팝업만 닫음
    setShowPopup(false);
    clearInterval(countdownIntervalRef.current);
    resetInactivityTimer(); // 사용자가 활동한 것으로 간주하고 타이머 리셋
  };

  const cancelRedirect = () => {
    setShowPopup(false);
    clearInterval(countdownIntervalRef.current);
    window.location.href = redirectTo;
  };

  useEffect(() => {
    const events = ["mousemove", "keydown", "scroll", "touchstart"];
    events.forEach(event =>
      window.addEventListener(event, resetInactivityTimer)
    );

    resetInactivityTimer(); // 초기 타이머 시작

    return () => {
      events.forEach(event =>
        window.removeEventListener(event, resetInactivityTimer)
      );
      clearTimeout(inactivityTimerRef.current);
      clearTimeout(popupTimerRef.current);
      clearInterval(countdownIntervalRef.current);
    };
  }, []);

  return {
    showPopup,
    confirmRedirect,
    cancelRedirect,
    remainingSeconds
  };
}

export default useInactivityRedirect;
